document.addEventListener("DOMContentLoaded", function () {
    const popupKey = "newsletter-popup-closed";
    const subscribedKey = "newsletter-popup-subscribed";

    function isDesignMode() {
        return typeof Shopify !== "undefined" && Shopify.designMode;
    }

    function hidePopupInDesignMode() {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup) return;

        popup.classList.remove("active", "closing");
        popup.style.display = "none";
        popup.style.opacity = "0";
        popup.style.visibility = "hidden";
        popup.style.pointerEvents = "none";
    }

    function handleLiveMode() {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup) return;

        const hideDuration =
            parseInt(popup.dataset.hideDuration, 10) * 3600000 || 86400000;
        const subscribeDuration =
            parseInt(popup.dataset.subscribeDuration, 10) * 86400000 || 30 * 86400000;
        const popupDelay = parseInt(popup.dataset.popupDelay, 10) * 1000 || 5000;
        const now = Date.now();

        let hideUntil = parseInt(localStorage.getItem(popupKey), 10) || 0;
        let subscribedUntil =
            parseInt(localStorage.getItem(subscribedKey), 10) || 0;

        if (!hideUntil && !subscribedUntil) {
            console.log(
                `LocalStorage vuoto! Mostro il popup tra ${popupDelay / 1000} secondi.`
            );
            showPopup(popupDelay);
            return;
        }

        if (isNaN(hideUntil) || isNaN(subscribedUntil)) {
            console.warn("Errore: Dati LocalStorage non validi. Resettando...");
            localStorage.removeItem(popupKey);
            localStorage.removeItem(subscribedKey);
            showPopup(popupDelay);
            return;
        }

        if (
            popup.dataset.popupEnabled === "true" &&
            now > hideUntil &&
            now > subscribedUntil
        ) {
            showPopup(popupDelay);
        } else {
            const nextActivation = Math.max(hideUntil, subscribedUntil);
            if (nextActivation > now) {
                console.log(
                    `Popup chiuso. Prossima attivazione: ${new Date(
                        nextActivation
                    ).toLocaleString()}`
                );
            } else {
                console.log("Popup riattivato.");
                showPopup(popupDelay);
            }
        }
    }

    function showPopup(delay) {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup || popup.classList.contains("active")) return;
        if (popup.dataset.popupEnabled !== "true") return;

        setTimeout(() => {
            popup.classList.add("active");
            console.log("Popup attivato.");
        }, delay);
    }

    function closePopupWithTimer() {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup || popup.classList.contains("closing")) return;

        popup.classList.add("closing");
        popup.classList.remove("active");

        setTimeout(() => {
            popup.classList.remove("closing");
        }, 500);

        const hideDuration = parseInt(popup.dataset.hideDuration, 10) * 3600000;
        const expirationTime = Date.now() + hideDuration;
        localStorage.setItem(popupKey, expirationTime);

        console.log(
            `Popup closed manually. Next activation on: ${new Date(
                expirationTime
            ).toLocaleString()}`
        );
    }

    function closePopupWithoutTimer() {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup || popup.classList.contains("closing")) return;

        popup.classList.add("closing");
        popup.classList.remove("active");

        setTimeout(() => {
            popup.classList.remove("closing");
        }, 500);

        console.log("Popup closed by clicking outside.");
    }

    function handleSubscription() {
        const popup = document.querySelector("#newsletter-popup");
        if (!popup) return;

        const subscribeDuration =
            parseInt(popup.dataset.subscribeDuration, 10) * 86400000;
        const expirationTime = Date.now() + subscribeDuration;
        localStorage.setItem(subscribedKey, expirationTime);

        console.log(
            `User subscribed. Popup hidden until: ${new Date(
                expirationTime
            ).toLocaleString()}`
        );

        closePopupWithTimer();
    }

    function initializePopup() {
        if (isDesignMode()) {
            hidePopupInDesignMode();
            document.addEventListener("shopify:section:load", hidePopupInDesignMode);
            document.addEventListener("shopify:section:select", hidePopupInDesignMode);
            document.addEventListener("shopify:block:select", hidePopupInDesignMode);
            return;
        }

        handleLiveMode();

        const popup = document.querySelector("#newsletter-popup");
        const closeButton = popup?.querySelector(".newsletter-popup__close");
        const form = popup?.querySelector("form");

        if (closeButton) {
            closeButton.addEventListener("click", closePopupWithTimer);
        }

        if (form) {
            form.addEventListener("submit", function (event) {
                event.preventDefault();
                handleSubscription();
            });
        }

        document.addEventListener("click", function (event) {
            const iubendaContainer = document.querySelector(".iubenda-cs-container");
            const popup = document.querySelector("#newsletter-popup");

            if (!popup) return;

            const popupContainer = popup.querySelector(".newsletter-popup__container");

            if (
                popup.classList.contains("active") &&
                !popup.contains(event.target) &&
                (!popupContainer || !popupContainer.contains(event.target)) &&
                (!iubendaContainer || !iubendaContainer.contains(event.target))
            ) {
                closePopupWithoutTimer();
            }
        });
    }

    initializePopup();
});